import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

export const Avatar = ({ size = 'medium', type = 'gorilla.png', altText, currentProfileImg }) => {
  return (
    <ClicAvatar
      src={
        currentProfileImg
          ? currentProfileImg
          : window.AVATAR_IMG_PATH  + type
      }
      alt={altText}
      size={size}
    />
  );
};

const ClicAvatar = styled.img`
  ${({ size }) => {
    // eslint-disable-next-line default-case
    switch (size) {
      case 'small':
        return `
          width: 20px;
          height: 20px;
        `;
      case 'medium':
        return `
          width: 24px;
          height: 24px;
        `;
      case 'large':
        return `
          width: 32px;
          height: 32px;
        `;
      case 'x-large':
        return `
          width: 50px;
          height: 50px;
        `;
    }
  }}
`;

Avatar.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']),
  type: PropTypes.oneOf([
    'gorilla.png',
    'girl.png',
    'happy.png',
    'robot.png',
    'zombie.png',
    'panda.png',
  ]),
  altText: PropTypes.string,
};